import { Sections } from "../../../util/types";
import Logros from "../../Home/SubSections/Logros";
import Iniciativas from "./Iniciativas";

const SubSectionsContainer:React.FC<{
    section:Sections
}>  = ({section}) => {
    
    switch (section) {
        case "initiatives":
            return <Iniciativas/>
        case "logros":
            return <Logros code="IR" />
        default:
            return null
    }
}

export default SubSectionsContainer